
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/learn/author/[...slug]",
      function () {
        return require("private-next-pages/learn/author/[...slug].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/learn/author/[...slug]"])
      });
    }
  